import React, { useEffect, useState } from "react"
import MuiCard from "@mui/material/Card"
import Stack from "@mui/material/Stack"
import logo from "../../assets/images/logo.jpeg"
import ColorModeSelect from "../../theme/ColorModeSelect"
import { resetPassword } from "../../redux/Slice/resetPasswordSlice"
import { Box, Button, CssBaseline, FormControl, FormControlLabel, FormLabel, InputAdornment, styled, TextField, Typography } from "@mui/material"
import { Visibility, VisibilityOff } from "@mui/icons-material"
import { useDispatch, useSelector } from "react-redux"
import { Link, Navigate, useNavigate, useParams } from "react-router-dom"
import { toast } from "sonner"
import { clearMessage } from "../../redux/Slice/message"
import background from "../../assets/images/ResetBg.svg"
import { setLoading } from "../../redux/Slice/loaderSlice"

const Card = styled(MuiCard)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignSelf: "center",
  width: "100%",
  padding: theme.spacing(4),
  gap: theme.spacing(2),
  margin: "auto",
  backgroundColor: "white",
   [theme.breakpoints.up("sm")]: {
    maxWidth: "450px",
  },
  // boxShadow: "hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px",
  // ...theme.applyStyles("dark", {
  //   boxShadow: "hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px",
  // }),
}))

const TopStrip = styled("div")(({ theme }) => ({
  width: "100%",
  height: "10px",
  backgroundColor: "green",
  position: "absolute",
  top: 0,
  left: 0,
}))

const ResetContainer = styled(Stack)(({ theme }) => ({
  height: "calc((1 - var(--template-frame-height, 0)) * 100dvh)",
  minHeight: "100%",
  backgroundImage: `url(${background})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  position: "relative",
  padding: theme.spacing(2),
  [theme.breakpoints.up("sm")]: {
    padding: theme.spacing(4),
  },

  // "&::before": {
  //   content: '""',
  //   display: "block",
  //   position: "absolute",
  //   zIndex: -1,
  //   inset: 0,
  //   backgroundImage: "radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))",
  //   backgroundRepeat: "no-repeat",
  //   ...theme.applyStyles("dark", {
  //     backgroundImage: "radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))",
  //   }),
  // },
}))

const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [showNewPassword, setShowNewPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const [passwordError, setPasswordError] = useState(false)
  const [passwordErrorMessage, setPasswordErrorMessage] = useState("")
  const [confirmPasswordError, setConfirmPasswordError] = useState(false)
  const [confirmPasswordErrorMessage, setConfirmPasswordErrorMessage] = useState("")
  const { data, loading, error } = useSelector((state) => state.reset)
  const dispatch = useDispatch()
  const { token } = useParams()
  const navigate = useNavigate()

  const message = useSelector((state) => state.message)

  useEffect(() => {
    if (message?.message) {
      toast(message.message)
      dispatch(clearMessage())
    }
  }, [message, dispatch])

  const handleClickShowNewPassword = () => setShowNewPassword((show) => !show)
  const handleClickShowConfirmPassword = () => setShowConfirmPassword((show) => !show)

  const handleSubmit = (e) => {
    e.preventDefault()
    if (validateInputs()) {
      const payload = { token, newPassword, confirmPassword }
      dispatch(setLoading(true));
      dispatch(resetPassword(payload))
        .unwrap()
        .then(() => {
          dispatch(setLoading(false));
          navigate("/login")
        })
        .catch((err) => {
          console.error(err)
          dispatch(setLoading(false));
    })
      console.error("Validation failed. Check your inputs 😒")
    }
  }

  const validateInputs = () => {
    const newPass = document.getElementById("new-password")
    const confirmPass = document.getElementById("confirm-password")
    let isValid = true

    if (!newPass.value || newPass.value.length < 6) {
      setPasswordError(true)
      setPasswordErrorMessage("Password must be at least 6 characters long.")
      isValid = false
    } else {
      setPasswordError(false)
      setPasswordErrorMessage("")
    }

    if (!confirmPass.value || confirmPass.value.length < 6) {
      setPasswordError(true)
      setPasswordErrorMessage("Password must be at least 6 characters long.")
      isValid = false
    } else {
      setPasswordError(false)
      setPasswordErrorMessage("")
    }

    // Validate newPassword and confirmPassword match
    if (newPass.value !== confirmPass.value) {
      setConfirmPasswordError(true)
      setConfirmPasswordErrorMessage("Passwords do not match.")
      isValid = false
    } else {
      setConfirmPasswordError(false)
      setConfirmPasswordErrorMessage("")
    }

    return isValid
  }

  if (data) {
    return <Navigate to="/login" />
  }

  return (
    <ResetContainer direction="column" justifyContent="space-between">
      <CssBaseline enableColorScheme />
      <TopStrip />
      <ColorModeSelect sx={{ position: "fixed", top: "3rem", right: "3rem" }} />
      <Card >
        <img srcSet={logo} src={logo} alt="logo" width={300} loading="lazy" />
        <Typography  variant="h5" sx={{ width: "100%" }}>
          Change Password
        </Typography>
        <Typography >Enter a new password below to change your password</Typography>
        
        <Box
          component="form"
          onSubmit={handleSubmit}
          noValidate
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            gap: 2,
          }}
        >
          <FormControl>
            <FormLabel htmlFor="password" sx={{ textAlign: "start" }}>
              New Password{" "}
            </FormLabel>
            <TextField
              error={passwordError}
              helperText={passwordErrorMessage}
              name="password"
              value={newPassword}
              placeholder="••••••"
              type={showNewPassword ? "text" : "password"}
              id="new-password"
              required
              fullWidth
              // variant="outlined"
              color={passwordError ? "error" : "primary"}
              onChange={(e) => setNewPassword(e.target.value)}
              slotProps={{
                input: {
                  endAdornment: <InputAdornment position="end">{showNewPassword ? <Visibility sx={{ cursor: "pointer" }} onClick={handleClickShowNewPassword} /> : <VisibilityOff sx={{ cursor: "pointer" }} onClick={handleClickShowNewPassword} />}</InputAdornment>,
                },
              }}
            />
          </FormControl>

          <FormControl>
            <FormLabel htmlFor="password" sx={{ textAlign: "start" }}>
              Confirm Password
            </FormLabel>
            <TextField
              error={confirmPasswordError}
              helperText={confirmPasswordErrorMessage}
              name="password"
              value={confirmPassword}
              placeholder="••••••"
              type={showConfirmPassword ? "text" : "password"}
              id="confirm-password"
              required
              fullWidth
              variant="outlined"
              color={confirmPasswordError ? "error" : "primary"}
              onChange={(e) => setConfirmPassword(e.target.value)}
              slotProps={{
                input: {
                  endAdornment: <InputAdornment position="end">{showConfirmPassword ? <Visibility sx={{ cursor: "pointer" }} onClick={handleClickShowConfirmPassword} /> : <VisibilityOff sx={{ cursor: "pointer" }} onClick={handleClickShowConfirmPassword} />}</InputAdornment>,
                },
              }}
            />
          </FormControl>

          <Button type="submit" fullWidth  onClick={validateInputs}  sx={{
              backgroundColor: "#2FB354",
              color: "white",
              marginTop:2,
              "&:hover": { backgroundColor: "#2FB354" },
            }}>
            Change Password
          </Button>
        </Box>
      </Card>
    <Typography  sx={{position:"absolute",bottom:5,right:5,color:"grey"}}>Copyright © 2025 Builder Pluss. All Rights Reserved </Typography>
      
    </ResetContainer>
  )
}

export default ResetPassword
